// --- Dependencies -------------------------------------------------------------------------------
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
// --- Our Modules --------------------------------------------------------------------------------
import usePermission from "@/hooks/usePermission";
// --- Logic --------------------------------------------------------------------------------------
type Props = { model: string; children: ReactNode };

/**
 * Hiding a tab is not enough — a member can type the path. This sends them home instead, and the API
 * refuses the same segment anyway, so the two agree.
 */
export default function RoleRoute({ model, children }: Props) {
    const { canAccess } = usePermission();
    if (!canAccess(model)) return <Navigate to="/" replace />;
    return <>{children}</>;
}
